module.exports = __webpack_public_path__ + "img/知乎.1ad4a89f.svg";